import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  // 重定向界面--测试用
  { path: '', redirect: '/marketForm/BPMF25040004' },

  // 营销表单
  {
    path: '/marketForm/:marketFormNo/:employeeId?',
    component: () => import('@/pages/marketForm'),
    meta: {
      title: '填写信息',
    },
  },
  {
    path: '/marketFormLandPage/:marketFormNo',
    component: () => import('@/pages/marketForm/marketFormLandPage'),
    meta: {
      title: '填写完成',
    },
  },
  {
    path: '/marketFormDeadline',
    component: () => import('@/pages/marketForm/deadline'),
    meta: {
      title: '报名截止',
    },
  },
  // 零元试听
  {
    path: '/zeroListening',
    component: () => import('@/pages/zeroListening'),
    meta: {
      title: '睿选优课─体验学习专区',
    },
  },
  {
    path: '/zeroListening/detail',
    component: () => import('@/pages/zeroListening/detail'),
  },
  // 404
  { path: '*', component: () => import('@/pages/notFound') },
];

const router = new VueRouter({
  routes,
});

/**
 * 路由监控修改 document.title
 */
router.beforeEach((to, from, next) => {
  //beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {
    //判断是否有标题
    document.title = to.meta.title;
  } else {
    document.title = '';
  }
  next();
});

export default router;
